// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1620919914073
      var cssReload = require("/Users/mh/work/praxisgemeinschaft-koeln/dev/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  